<template>
  <div class="wrapper">
    <div class="full-page">
      <div class="content">
        <router-view></router-view>
      </div>
<!--      <footer class="footer">-->
<!--        <div class="container-fluid">-->
<!--          <div class="copyright">-->
<!--            &copy; 2020-->
<!--          </div>-->
<!--        </div>-->
<!--      </footer>-->
    </div>
  </div>
</template>

<script>
  export default {
    name: "CreditLayout"
  }
</script>

<style scoped>

</style>
